import React from 'react'
import GatewayType from '../GatewayType'
import { UseOldUI } from '../../utils/GeneralUtil'

const ChangeRequest: GatewayType = () => {
  return <UseOldUI />
}

export default ChangeRequest
